import Svg, { Circle, G } from 'react-native-svg'

const primaryBlueColor = '#0070b6 '
const outerCircleRadiusBuffer = 20

interface CircleSvgInterface {
  height?: number
  outerCircleDirection?: 'left' | 'right'
}

const returnLeftTransformedValue = (isLeft: boolean, height: number) => {
  const isSmallCircle = height < 150
  if (isLeft) {
    return {
      outer: 'translate(-114 -954)',
      inner: `translate(${isSmallCircle ? 112 : 114} 954)`,
    }
  } else {
    return {
      outer: 'translate(-134 -954)',
      inner: `translate(${isSmallCircle ? 141 : 149} 954)`,
    }
  }
}

export const CircleSvg = ({ height = 150, outerCircleDirection = 'right' }: CircleSvgInterface) => {
  const width = height + outerCircleRadiusBuffer
  const isLeft = outerCircleDirection === 'left'
  const xRadius = height / 2
  const transformedVal = returnLeftTransformedValue(isLeft, height)
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <G transform={transformedVal.outer}>
        <G transform={transformedVal.inner} stroke={primaryBlueColor} fill="none">
          {/* For the outer diameter not to be overlapped so minus by 0.5 to have some cushion!*/}
          <Circle cx={xRadius} cy={xRadius} r={xRadius - 0.5} />
        </G>
        <Circle cx={xRadius} cy={xRadius} r={xRadius} transform="translate(134 954)" fill={primaryBlueColor} />
      </G>
    </Svg>
  )
}
